import React, {Component} from "react";
import sanitizeHtml from "sanitize-html";
import {Cell, Column, Table} from "fixed-data-table-2";
import "../../../../node_modules/fixed-data-table-2/dist/fixed-data-table.min.css";
import PropTypes from "prop-types";
import store from "../../../lib/store";
import isMobile from "is-mobile";
import Avatar from "material-ui/Avatar";
import _ from "lodash";
import ReactSVG from 'react-svg';
import "./Datagrid.css";

class DataGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {width: false, height: false};
        this.updateDimensions = this.updateDimensions.bind(this);

    }

    updateDimensions(e) {
        var {x, y} = this.getWindowSize();
        this.setState({width: x, height: y});
    }

    getWindowSize() {
        var w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight || e.clientHeight || g.clientHeight;
        return {x, y};
    }

    componentDidMount() {
        var {x, y} = this.getWindowSize();
        this.setState({width: x, height: y});
        window.addEventListener('resize', this.updateDimensions);
        var target = window; // this can be any scrollable element
        var last_y = 0;
        window.addEventListener('touchmove', function (e) {
            var scrolly = target.pageYOffset || target.scrollTop || 0;
            var direction = e.changedTouches[0].pageY > last_y ? 1 : -1;
            if (direction > 0 && scrolly === 0) {
                e.preventDefault();
            }
            last_y = e.changedTouches[0].pageY;
        }, {passive: false});
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);

    }

    shouldComponentUpdate(nextProps, nextState){
        if(!nextState.width || !nextState.height)
            return false;
        if(!nextProps.topics || !nextProps.users)
            return false;
        if(
            !_.isEqual(nextProps.topics, this.props.topics) ||
            !_.isEqual(nextProps.users, this.props.users) ||
            (nextState.width !== this.state.width) ||
            (nextState.height !== this.state.height)
        ) {
            return true;
        }
        return false;
    }

    strip(html)
    {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    timeConverter(UNIX_timestamp){
        var a = new Date(UNIX_timestamp);
        var year = a.getFullYear();
        var month = a.getMonth()+1;
        var date = a.getDate();
        var hour = a.getHours();
        var min = a.getMinutes();
        var sec = a.getSeconds();
        return year+'/'+month+'/'+date;
        var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
        return time;
    }

    render() {
        if(!this.state.width || !this.state.width)
            return <span/>
        const ColumnsTag = this.props.users.map(function (user) {
            var mateIcon = user.isMate ? <ReactSVG
                path="/static/image/chair.svg"
                style={{width: 35, position:'absolute', right:1, top:10}}
            /> : null;
            return (
                <Column
                    key={user.key}
                    header={
                        <Cell>
                                <a href={`/user/${user.key}`} className="UserLink" onClick={function(e){
                                    e.preventDefault();
                                    store.dispatch({type:'USER_PROFILE_OPEN', id:user.key, onClose:function(){
                                            window.history.pushState(null, null, `/user/${this.props.campaignId}`);
                                    }.bind(this)});
                                }}>
                                    <Avatar backgroundColor="white" className="avatar" size={35} src={user.photoURL}/>
                                    {user.name}
                                    {mateIcon}
                                </a>
                        </Cell>
                    }
                    cell={({rowIndex, ...props}) => {
                        let cellData = user.statuses[this.props.topics[rowIndex].key];
                        let updated = cellData.status > 0 ? <span className="date">{this.timeConverter(cellData.updated)}</span> : null;
                        return (
                            <Cell className={cellData.status > 0 ? 'marked' : ''} {...props} onClick={function (event, status, user) {
                                this.props.onClickCell(event, status, user);
                            }.bind(
                                this,
                                null,
                                cellData,
                                user
                            )}>
                                {updated}{this.strip(cellData.msg)}{cellData.status > 1 ? <span className="status-number">{cellData.status}</span> : null}
                            </Cell>
                        );
                    }}
                    width={Math.min(400, window.screen.width*7/10)}
                />
            );
        }.bind(this));
        return (
            <Table
                className="Datagrid"
                touchScrollEnabled={true}
                rowHeight={72}
                rowsCount={this.props.topics.length}
                width={this.state.width}
                height={this.state.height}
                keyboardScrollEnabled={true}
                headerHeight={50}>
                <Column
                    header={<Cell/>}
                    cell={({rowIndex, ...props}) => {
                        return (
                            <Cell {...props}>
                                <div
                                    dangerouslySetInnerHTML={{__html: sanitizeHtml(this.props.topics[rowIndex].title)}}/>
                            </Cell>
                        )
                    }}
                    width={300}
                    fixed={isMobile() ? false : true}
                />
                {ColumnsTag}
            </Table>
        );
    }
}
DataGrid.propTypes = {
    onClickCell: PropTypes.func.isRequired
}
export default DataGrid;


// WEBPACK FOOTER //
// ./src/container/campaign/component/Datagrid.js